export default __webpack_public_path__ + "static/media/P-2U-REAR.4eb3765e.png";